import $ from "cash-dom";

export default (function () {
    var selector = "[data-lightbox]";

    function init() {
        if (!$(selector).length) return;

        jdmn.log("function_zoom-image.js initialized", "green");

        var $button = $(selector);
        var $lightbox = $(
            `<div id="lightbox" class="fixed inset global transition-md fade-in bg-darken scroll-x scroll-y z-4"></div>`,
        );
        var $closeButton =
            $(`<button class="tab pointer aspect-1:1 bg-lighten hover:bg-white c-accent width-2.0 fixed bottom-1.0 right-1.0 radius-round flex center-content stack" title="${jdmn_l10n.close}">
                    <svg class="icon stroke-sm" style="aspect-ratio: 1"><use href="#close"></use></svg>
                    <span class="sr-text">${jdmn_l10n.close}</span>
                </button>`);

        function closeHandler() {
            $closeButton.off("click");
            $lightbox.removeClass("on").on("transitionend", function () {
                $lightbox.find("img").remove();
                $lightbox.remove();
                $("html").removeClass("scroll-locked");
            });
        }

        $button.on("click", function () {
            console.log("openlightbox");
            var $instance = $(this).parents(".layout");
            var $image = $instance.find("img");
            var $clone = $image.clone();

            var theme = $instance.parents("[data-theme]").data("theme");
            var imageRatio = $image.width() / $image.height();
            var parentRatio = window.innerWidth / window.innerHeight;

            imageRatio = Math.ceil(imageRatio * 100) / 100;
            parentRatio = Math.ceil(parentRatio * 100) / 100;

            if (imageRatio < parentRatio) {
                $clone.css({ width: "100%", height: "auto", "min-width": "unset", "min-height": "unset" });
            }

            if (imageRatio > parentRatio) {
                $clone.css({ width: "auto", height: "100%", "min-width": "unset", "min-height": "unset" });
            }

            $lightbox.attr("data-theme", theme);
            $lightbox.append($closeButton);
            $lightbox.append($clone);
            $("body").append($lightbox);

            setTimeout(function () {
                $lightbox.addClass("on");
                $("html").addClass("scroll-locked");
            }, 0);
        });

        $closeButton.on("click", closeHandler);
        $(window).on("escKey", closeHandler);
    }

    $(document).ready(init);
})();
